/**
 * Onde os avisos flutuantes aparecem.
 *
 * Montado uma vez, na raiz. Cada tela que montasse o seu criaria uma
 * pilha própria, e dois avisos disparados de lugares diferentes
 * apareceriam em cantos diferentes da tela.
 *
 * O tema vem pelas variáveis que a biblioteca expõe, e não por `style` em
 * `toastOptions`. O `style` de lá vira atributo inline no mesmo elemento
 * que a biblioteca usa para guardar `--index`, `--offset` e
 * `--initial-height`; pintar por ali funciona hoje e passa a competir com
 * o cálculo dela a cada atualização. As variáveis são a superfície que
 * ela mantém para isso.
 *
 * Posição embaixo, e não em cima: no celular o topo é onde fica o saldo, e
 * um aviso cobrindo o saldo logo depois de uma operação de dinheiro é
 * exatamente o momento em que a pessoa quer conferir o número.
 */
import { Toaster } from 'sonner';

export function Avisos() {
  return (
    <Toaster
      // O padrão da biblioteca é "Notifications alt+T", em inglês, e é
      // isso que um leitor de tela anuncia. O resto do aplicativo está em
      // português; a região de avisos também precisa estar.
      containerAriaLabel="Avisos"
      position="bottom-center"
      // Fecha sozinho, mas devagar o bastante para uma frase de duas
      // linhas ser lida por inteiro.
      duration={5000}
      closeButton
      style={
        {
          '--normal-bg': 'var(--card)',
          '--normal-text': 'var(--card-foreground)',
          '--normal-border': 'var(--border)',
          '--success-bg': 'var(--card)',
          '--success-text': 'var(--primary)',
          '--success-border': 'var(--border)',
          '--error-bg': 'var(--card)',
          '--error-text': 'var(--danger)',
          '--error-border': 'var(--border)',
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: 'aviso-flutuante',
          title: 'font-semibold',
          description: 'text-muted-foreground',
        },
      }}
    />
  );
}
